import { TruckerAway } from 'constants/enums/trucker';
import { IReducerFn } from 'context/type';
import { concatMetaAreaCodes } from 'helpers';
import { TFreightCard, TTruckerState } from './truckers.type';

export const TruckersReducer: IReducerFn<TTruckerState> = (state, { type, payload }) => {
  switch (type) {
    case 'truckers_meta_set':
      return {
        ...state,
        meta: concatMetaAreaCodes(state.meta, payload as TFreightCard),
      };
    case 'truckers_driver_active_set':
      return {
        ...state,
        activeDriver: payload.activeDriver,
        profileAutoLoad: false,
      };
    case 'truckers_driver_auto_active_set':
      return {
        ...state,
        activeDriver: payload.activeDriver,
        profileAutoLoad: true,
      };
    case 'truckers_sort_set':
      return {
        ...state,
        sort: payload.sort,
      };
    case 'truckers_vehicles_set':
      return {
        ...state,
        vehicles: payload,
      };
    case 'truckers_vehicles_clear':
      return {
        ...state,
        vehicles: [],
      };
    case 'truckers_filter_truckerType_set':
      return {
        ...state,
        truckerType: payload.truckerType,
      };
    case 'truckers_areaCodes_set':
      return {
        ...state,
        areaCodes: payload,
      };
    case 'truckers_radius':
      return {
        ...state,
        radius: payload.radius,
      };
    case 'hide_freight_code_set':
      return {
        ...state,
        scrollHideItems: payload,
      };
    case 'set_is_filter_applied':
      return {
        ...state,
        isFilterApplied: payload,
      };
    default:
      return state;
  }
};

TruckersReducer.key = 'truckers';
TruckersReducer.initialState = {
  meta: null,
  radius: TruckerAway.INITIAL_VALUE,
  activeDriver: null,
  profileAutoLoad: false,
  sort: null,
  truckerType: [],
  vehicles: [],
  areaCodes: [],
  scrollHideItems: false,
  isFilterApplied: false,
};
